import React from 'react';

const Testimonials: React.FC = () => {
  return (
    <section className="section bg-gray-50">
      <div className="container">
        <h2 className="section-title">What People Are Saying</h2>
        <p className="section-subtitle">
          Hear from those who have experienced transformation through our programs
        </p>

        {/* Featured testimonial — TEDx */}
        <div
          className="testimonial-card"
          style={{
            maxWidth: '860px',
            margin: '0 auto 48px auto',
            borderTop: '4px solid #15803d',
          }}
        >
          <div className="testimonial-content">
            <div className="quote-icon">
              <span>❝</span>
            </div>
            <blockquote className="testimonial-text">
              "When I was preparing for my TEDx talk, I wondered how I'd find the courage—and, more importantly, how to deliver it in a way that truly connected with people. Natalie was my angel and ally throughout the process. She has a unique ability to truly hear what you're trying to express and quickly offer techniques that shape it into something clear, compelling, and impactful. As a trained actor, artist, and business owner, she wears many hats—and that blend uniquely positions her to support clients in a way that really counts. Even in the stickiest parts of the creative work, she had me smiling and moving forward. Natalie is uniquely positioned to give your creative process wings and help you connect to the artist within."
            </blockquote>
            <div
              className="testimonial-author"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                flexWrap: 'wrap',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div className="author-image">
                  <img
                    src="/lacey-lavigna.jpg"
                    alt="Dr. Lacey LaVigna - TEDx Speaker"
                    className="author-photo"
                  />
                </div>
                <div className="author-info">
                  <div className="author-name">Dr. Lacey LaVigna</div>
                  <div className="author-title">TEDx Speaker</div>
                </div>
              </div>
              <img
                src="/TED_three_letter_logo.svg"
                alt="TEDx"
                style={{ height: '30px', flexShrink: 0 }}
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="quote-icon">
                <span>❝</span>
              </div>
              <blockquote className="testimonial-text">
                "The Artist's Way with Natalie was the best gift I gave myself last year. Not only did I get IRL time with a group of amazing ladies each week, Natalie created a supportive environment for us all to reconnect with our inner artists while also connecting with each other and sharing our creative gifts."
              </blockquote>
              <div className="testimonial-author">
                <div className="author-image">
                  <img 
                    src="/Ashlea_HS.png" 
                    alt="Ashlea - Program Participant"
                    className="author-photo"
                  />
                </div>
                <div className="author-info">
                  <div className="author-name">Ashlea</div>
                  <div className="author-title">Artist's Way Program Participant</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="quote-icon">
                <span>❝</span>
              </div>
              <blockquote className="testimonial-text">
                "Participating in Natalie's The Artist's Way group was truly life-changing. She guides with such openness, compassion, and a deep sensitivity to each person's unique cultural and personal background. Natalie has a gift for creating a space where everyone feels safe, seen, and heard. Her ability to foster group cohesion is masterful—each session felt like a vibrant, supportive world of creativity and growth. Thanks to her steady, inspired facilitation, I not only uncovered blocks I didn't know I had but also gained the confidence to dream bigger—and follow through. In the six months since completing the group, I've achieved every single goal I set during our time together, including realizing a lifelong dream of opening an immersive art and performance venue. Natalie is more than a facilitator—she's a catalyst for artistic synergy and transformation. I'm endlessly grateful."
              </blockquote>
              <div className="testimonial-author">
                <div className="author-image">
                  <img 
                    src="/testimonial-headphones.jpg" 
                    alt="Program Participant"
                    className="author-photo"
                  />
                </div>
                <div className="author-info">
                  <div className="author-name">Artist & Venue Owner</div>
                  <div className="author-title">Artist's Way Program Participant</div>
                </div>
              </div>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="quote-icon">
                <span>❝</span>
              </div>
              <blockquote className="testimonial-text">
                "Working with Natalie has been a gift in finding the courage to tell my own story. She has an extraordinary ability to listen from the receiving end of a message—to notice the moments in a story that I might pass over because they feel ordinary or overly familiar to me, but that are exactly the moments an audience needs to notice. She catches what gets lost when we become too accustomed to our own experiences, and gently draws it forward. There is something masterful about the way Natalie does this. She helped me recognize that the story I had to tell was already enough—and then had helped me immensely with finding the presence and courage to truly tell it."
              </blockquote>
              <div className="testimonial-author">
                <div className="author-image">
                  <img
                    src="/courtney-reiman.jpg"
                    alt="Courtney Maree Reiman - Acupuncturist &amp; Business Owner"
                    className="author-photo"
                  />
                </div>
                <div className="author-info">
                  <div className="author-name">Courtney Maree Reiman</div>
                  <div className="author-title">Acupuncturist &amp; Business Owner</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center" style={{ marginTop: '48px' }}>
          <a href="#contact" className="btn btn-primary" style={{ fontSize: '18px', padding: '16px 32px' }}>
            Start Your Transformation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;